<div class="alert alert-danger">{{ 'error_page.' + (route.snapshot.params.type || 404) | translate  }}</div>